import PATHS from '~/constants/paths';

export const AURI_PATH = PATHS.auri;

export default {
  home: '/',
  encode: 'encode',
  decode: 'decode',
  about: 'about',
};
